import Papa from "papaparse";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { serializeValue } from "../utils/firestoreValueUtils";

function flattenRow(row, fields, includeId) {
  const flat = includeId ? { id: row.id } : {};
  const data = row.data || row.after || row.before || {};
  const keys = fields?.length ? fields : Object.keys(data);
  keys.forEach((k) => {
    flat[k] = serializeValue(data[k]);
  });
  return flat;
}

export function exportMatchingCsv(rows, { fields, includeId = true, filename }) {
  const flat = rows.map((r) => flattenRow(r, fields, includeId));
  const csv = Papa.unparse(flat);
  saveAs(new Blob([csv], { type: "text/csv" }), filename || "export.csv");
}

export function exportMatchingExcel(rows, { fields, includeId = true, filename }) {
  const flat = rows.map((r) => flattenRow(r, fields, includeId));
  const ws = XLSX.utils.json_to_sheet(flat);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Matching");
  XLSX.writeFile(wb, filename || "export.xlsx");
}

export function exportMatchingJson(rows, { fields, includeId = true, filename }) {
  const out = rows.map((r) => flattenRow(r, fields, includeId));
  saveAs(
    new Blob([JSON.stringify(out, null, 2)], { type: "application/json" }),
    filename || "export.json"
  );
}

export function exportMatchingPdf(rows, { fields, includeId = true, filename, title }) {
  const doc = new jsPDF({ orientation: "landscape" });
  doc.setFontSize(14);
  doc.text(title || "Matching Documents Export", 14, 16);
  const flat = rows.map((r) => flattenRow(r, fields, includeId));
  const headers = flat.length ? Object.keys(flat[0]) : ["id"];
  autoTable(doc, {
    head: [headers],
    body: flat.map((r) => headers.map((h) => String(r[h] ?? ""))),
    startY: 22,
    styles: { fontSize: 7 },
  });
  doc.save(filename || "export.pdf");
}
